import { memo } from "react";
import type { LoaderCommonProps } from "../types";
import { tokens } from "../styles/tokens";
import { Skeleton } from "./Skeleton";

export const ListLoader = memo(function ListLoader({
  rows = 5,
  animated = true,
  width = "100%",
  height,
  className,
}: LoaderCommonProps) {
  const safeRows = Math.max(1, rows);

  return (
    <div
      className={className}
      style={{
        width,
        height,
        background: "#fff",
        borderRadius: tokens.radius,
        boxShadow: tokens.shadow,
        overflow: "hidden",
      }}
    >
      {Array.from({ length: safeRows }).map((_, i) => (
        <div
          key={`item-${i}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: tokens.spacing.md,
            padding: tokens.spacing.md,
            borderBottom: i < safeRows - 1 ? "1px solid #f5f5f5" : undefined,
          }}
        >
          <Skeleton width={40} height={40} borderRadius={tokens.radiusFull} animated={animated} />
          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
            <Skeleton width="60%" height={16} animated={animated} />
            <Skeleton width="85%" height={12} animated={animated} />
          </div>
        </div>
      ))}
    </div>
  );
});
